import { mergeSharedTranslations } from "@shared/utils/mergeSharedTranslations";

import { login } from "./sso_login";

export const en = mergeSharedTranslations({
  login,
});
